<script setup>
import { useI18n } from 'vue-i18n';

import { inject, ref } from 'vue';
import { useAutoAnimate } from '@formkit/auto-animate/vue';

// Icons
import minus from '@i/minus.svg';
import plus from '@i/plus.svg';

// Components
import Icon from '@/Components/Images/Icon.vue';
import MenuCardMenuItem from './MenuCardMenuItem.vue';

const props = defineProps({
    menu: Object,
});

const [listContainer] = useAutoAnimate();
const current = ref(null);

const route = inject('route');
const { t } = useI18n();
</script>

<template>
    <div>
        <div class="flex justify-center">
            <h2 class="mt-16 " v-html="menu.title" v-if="menu.title"></h2>
        </div>

        <ul ref="listContainer" v-if="menu.menus">
            <li class="py-3" v-for="(item, i) in menu.menus" :key="i" v-auto-animate>
                <div
                    class="flex items-center justify-between gap-6 cursor-pointer"
                    @click="current = current === i ? false : i"
                >
                    <div class="max-w-full mb-4 text-2xl font-bold" v-if="item.menu_title">
                        {{ item.menu_title }}
                    </div>

                    <Icon
                        :icon="minus"
                        class="w-5 h-5 rounded-full bg-gray-light shrink-0"
                        v-if="i === current"
                        :alt="t('minus icon')"
                    />
                    <Icon
                        :icon="plus"
                        class="w-5 h-5 rounded-full bg-gray-light shrink-0"
                        :alt="t('plus icon')"
                        v-else
                    />
                </div>

                <MenuCardMenuItem v-if="i === current && item.menu_card_item" :menuItem="item.menu_card_item" />
            </li>
        </ul>
    </div>
</template>
